<template>
  <next-race-card
    v-if="recommendation"
    :result-id="resultId"
    :recommendation="recommendation"
    show-road-link
  />
</template>
<script>
import { mapActions } from "vuex";
import NextRaceCard from "@/views/ResultPage/components/NextRaceCard.vue";

export default {
  components: { NextRaceCard },
  props: {
    resultId: { type: [String, Number], default: null },
  },
  data: () => ({ recommendation: null }),
  methods: {
    ...mapActions(["getNextRace"]),
  },
  async mounted() {
    this.recommendation = await this.getNextRace(this.resultId);
    if (this.recommendation) this.$emit("found", this.recommendation);
  },
};
</script>
